namespace pixi_ui.component {
    export class Input implements IComponent {
        public enabled: boolean;

        constructor(enabled: boolean) {
            this.enabled = enabled;
        }

        public attach(element: Element): void {
            element.interactive = this.enabled;
            element.buttonMode = this.enabled;
        }

        public detach(element: Element): void {
            element.interactive = false;
            element.buttonMode = false;
        }

        public resize(element: Element): void {}
    }
}
